import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../../service";

const initialState: any = {
  listItems: [],

  activeItem: {},
  loading: false,
  activeItemloading: false,
};
export const getPartnerVulnerabilityListItems = createAsyncThunk(
  "partnerVulnerability/getPartnerVulnerabilityListItems",
  async (Id: string, { rejectWithValue }) => {
    try {
      const response: any = await apiServices.client.vulnerability.get(Id);

      const { isError, data } = response.data;
      if (isError || !data) {
        return rejectWithValue("Failed to fetch  list");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const getPartnerVulnerabilityDetailById = createAsyncThunk(
  "partnerVulnerability/getPartnerVulnerabilityDetailById",
  async (Id: string, { getState, rejectWithValue }) => {
    if (!Id) return rejectWithValue("Invalid Id ID");

    // Access the current state
    const state: any = getState();

    const itemList = state.partnerVulnerability.listItems;

    // Find the valuation detail by ID in the listItems array
    const itemDetail = itemList.find(
      (item: any) => item.vulnerability_id === Id
    );
    if (itemDetail) {
      return itemDetail; // Return the detail if found
    } else {
      return rejectWithValue("item detail not found in state");
    }
  }
);

export const partnerVulnerabilitySlice = createSlice({
  name: "partnerVulnerability",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPartnerVulnerabilityListItems.pending, (state) => {
        state.loading = true;
        state.listItems = [];
      })
      .addCase(getPartnerVulnerabilityListItems.fulfilled, (state, action) => {
        state.loading = false;
        state.listItems = action.payload;
      })
      .addCase(getPartnerVulnerabilityListItems.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching  list:", action.payload);
      })
      .addCase(getPartnerVulnerabilityDetailById.pending, (state) => {
        state.activeItemloading = true;
        state.activeItem = {};
      })
      .addCase(getPartnerVulnerabilityDetailById.fulfilled, (state, action) => {
        state.activeItemloading = false;
        state.activeItem = action.payload;
      })
      .addCase(getPartnerVulnerabilityDetailById.rejected, (state, action) => {
        state.activeItemloading = false;
        console.error("Error fetching  details:", action.payload);
      });
  },
});
export const {} = partnerVulnerabilitySlice.actions;
export default partnerVulnerabilitySlice.reducer;
